import React from 'react';
import client from '../../../utils/ajax/client';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { NotificationManager } from 'react-notifications';

import * as AuthActions from '../../../actions/auth';

import {ROUTE_SIGNIN, ROUTE_HOME} from '../../../constants/routeconstants';
import {replace} from "react-router-redux";

class SignInPage extends React.Component {

    static getId() {
        return ROUTE_SIGNIN;
    }

    static getAllowedRoles() {
        return []; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            username : props.user.username ? props.user.username : "", // fill up username if the user was redirected here after sign up
            password : "",
            forgotPasswordMode : false,
            passwordResetMailSent : false,
            passwordResetEmail: "",  // The e-mail address the password reset mail was sent to
            showInvalidCredentialsWarning : false
        };
    }

    render() {

        const invalidCredentialsWarning = !this.state.showInvalidCredentialsWarning ? "" : (
            <div style={{color:"red", marginTop:"10px"}}>Wrong user name or password.</div>
        );

        const submitButtonDisabled = this.state.username == "";

        const passwordResetMailInfoHtml = this.state.passwordResetMailSent
            ? <div style={{marginTop:"10px"}}>You can now reset your password. An email has been send to <b>{this.state.passwordResetEmail}</b> containing a link you can use to reset your password. The link will be functional for half an hour.</div>
            : "";

        const titleText = this.state.forgotPasswordMode ? "Reset password" : "Login";
        const submitButtonText = this.state.forgotPasswordMode ? "Send mail" : "Log in";
        const changeModeButtonText = this.state.forgotPasswordMode ? "Back" : "Forgotten your password?";
        const hidePasswordFieldStyle = this.state.forgotPasswordMode ? {visibility:"hidden"} : {};

        // TODO: Remove fake login buttons.
        return (
            <div className="signin-page">
                {/*<div className="page-title">
                </div>*/}
                <div className="sub-page-content">
                    <div  className="signin-button">
                        <button onClick={(event) => {
                            event.preventDefault();
                            window.location = '/login/drupal';
                        }} className="btn-primary" type="submit">Log på</button>
                        {/*<button onClick={(event) => {
                            client({
                                method: "POST",
                                path: "/login",
                                entity: {
                                    username : 'system-admin',
                                    password : 'admin',
                                },
                                headers: {'Content-Type': 'application/json'}
                            }).then(response => {
                                this.props.dispatch(replace(ROUTE_HOME))
                            });
                        }} className="btn-primary" type="submit">Fake Log in as Admin</button>
                        {/*<button onClick={(event) => {
                            client({
                                method: "POST",
                                path: "/login",
                                entity: {
                                    username : 'club-admin',
                                    password : 'admin',
                                },
                                headers: {'Content-Type': 'application/json'}
                            }).then(response => {
                                this.props.dispatch(replace(ROUTE_HOME))
                            });
                        }} className="btn-primary" type="submit">Fake Log in as Club Admin</button>*/}
                    </div>
                    <div className="signin-message">
                        {this.props.auth.isAuthenticated && !this.props.auth.isMainAdmin && !this.props.auth.isClubAdmin ? <p>Du er logget på som <b>{this.props.auth.displayName}</b>, men er hverken oprettet som foreningsadministrator, sektionsadministrator eller hovedadministrator.</p> : null}
                    </div>
                </div>
            </div>
        );
        /*return (
            <div className="signin-page">
                <div className="page-title">
                    <h1>{titleText}</h1>
                </div>
                <div className="page-content">
                    <form className="user-form">
                        <div className="content-box editor-container">
                            <div className="sub-container">
                                <div className="field-row">
                                    <label htmlFor="username">User name</label>
                                    <div><input className="field-1" type="text" id="username" placeholder="Enter email" value={this.state.username} onChange={this.onUsernameChanged} /></div>
                                </div>
                                <div className="field-row" style={hidePasswordFieldStyle}>
                                    <label htmlFor="password">Password</label>
                                    <div><input className="field-1" type="password" id="password" placeholder="Enter password" value={this.state.password} onChange={this.onPasswordChanged} /></div>
                                </div>
                            </div>

                            <div>
                                <button type="button" className="btn-transparent" onClick={this.changeMode}>
                                    {changeModeButtonText}
                                </button>
                                <button type="submit" className="btn-primary btn-login" disabled={submitButtonDisabled} onClick={this.state.forgotPasswordMode ? this.resetPassword : this.login}>
                                    {submitButtonText}
                                </button>
                            </div>

                            {invalidCredentialsWarning}

                            <div style={{clear:"both"}} />

                            {passwordResetMailInfoHtml}

                            <p>
                                Not yes a member? <Link to={ROUTE_SIGNUP}>Register here</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        );*/
    }

    onUsernameChanged = e => {
        this.setState({
            username: e.target.value,
            showInvalidCredentialsWarning: false
        });
    };

    onPasswordChanged = e => {
        this.setState({
            password: e.target.value,
            showInvalidCredentialsWarning: false
        });
    };

    changeMode = e => {
        e.preventDefault();
        this.setState({
            forgotPasswordMode: !this.state.forgotPasswordMode,
            showInvalidCredentialsWarning: false
        });
    };

    login = (e) => {
        e.preventDefault();

        const dispatch = this.props.dispatch;

        const username = this.state.username.trim();
        const password = this.state.password.trim();

        let redirectRoute;
        if (this.props.location.query && this.props.location.query.next) {
            redirectRoute = this.props.location.query.next;
        } else {
            redirectRoute = '/';
        }
        dispatch(AuthActions.loginUser(username, password, redirectRoute, this.onInvalidCredentials));
    };

    resetPassword = (e) => {
        e.preventDefault();

        const dispatch = this.props.dispatch;

        const username = this.state.username.trim();

        dispatch(AuthActions.requestPasswordReset(username, (email) => {
            this.setState({ forgotPasswordMode: false, passwordResetMailSent: true, passwordResetEmail: email, password: "" });
            NotificationManager.success("Your can now be reset.", "Email send", 4000);
        }));
    };

    onInvalidCredentials = () => {
        this.setState({showInvalidCredentialsWarning: true});
    };
}

const mapStateToProps = (state) => ({
    auth: {
        isAuthenticated: state.auth.isAuthenticated,
        isAuthenticating: state.auth.isAuthenticating,
        statusText: state.auth.statusText,
        displayName: state.auth.displayName,
        isMainAdmin: state.auth.isMainAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.displayName,
    },
    user: {
        username: state.user.username
    }
});

export default connect(mapStateToProps)(SignInPage);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/signin/SignInPage.js